import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getAll(filter = null) {
  const param = filter ? { params: filter } : null;
  const response = await http.getDataParam(`/user`, param).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function show(id: number | string) {
  const response = await http.getData(`/user/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function updateMapCdoc(id: number | string, data: object) {
  const response = await http
    .putData(`/user/${id}/map-cdoc`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateSignature(id: number | string, file: string | Blob) {
  const formData = new FormData();

  formData.append("image", file);

  const response = await http
    .postData(`/user/${id}/signature`, formData)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateSignatureBase64(id: number | string, image: string) {
  const response = await http
    .postData(`/user/${id}/signature-base64`, { user_id: id, image: image })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function updateUserRole(id: number | string, data: object) {
  const response = await http.putData(`/user/${id}/role`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

/** Ambil profession-role yang sedang ter-assign ke user. */
async function getProfessionRoles(id: number | string) {
  const response = await http
    .getData(`/user/${id}/profession-role`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

/** Set profession-role user (array kosong = lepas semua). Khusus Super Admin. */
async function updateProfessionRoles(id: number | string, roleIds: string[]) {
  const response = await http
    .putData(`/user/${id}/profession-role`, { role_ids: roleIds })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  getAll,
  show,
  updateMapCdoc,
  updateSignature,
  updateSignatureBase64,
  updateUserRole,
  getProfessionRoles,
  updateProfessionRoles
};
